import { createReducer } from 'redux-act';
import moment from 'moment';

import {
  PROGRAMME_FETCH_DATA_INIT,
  PROGRAMME_FETCH_DATA_SUCCESS,
  PROGRAMME_FETCH_DATA_FAIL,
  PROGRAMME_DELETE_INIT,
  PROGRAMME_DELETE_SUCCESS,
  PROGRAMME_DELETE_FAIL,
  PROGRAMME_CLEAR_DATA,
  PROGRAMME_CREATE_INIT,
  PROGRAMME_CREATE_SUCCESS,
  PROGRAMME_CREATE_FAIL,
  PROGRAMME_MODIFY_INIT,
  PROGRAMME_MODIFY_SUCCESS,
  PROGRAMME_MODIFY_FAIL,
  PROGRAMME_CLEAN_UP,
  PROGRAMME_CLEAR_DATA_LOGOUT,
  SET_PROGRAMME,
} from 'state/actions/programme';

const initialState = {
  list: [],
  programme: {
    name: '',
    description: '',
    siteId: '',
    screenId: '',
    modifiedAt: moment(Date.now()).format('DD-MM-YY hh:mm:ss'),
    modifiedBy: '',
    files: [],
    deletedFiles: [],
  },
  loading: false,
  error: {
    errors: null,
    messsage: '',
  },
  success: false,
  deleted: false,
  updated: false,
};

export const programmeReducer = createReducer(
  {
    [PROGRAMME_FETCH_DATA_INIT]: () => ({
      ...initialState,
      loading: true,
    }),
    [PROGRAMME_FETCH_DATA_SUCCESS]: (state, payload) => ({
      ...state,
      list: payload.list || [],
      programme: payload.programme || initialState.programme,
      loading: false,
      error: {
        errors: null,
        messsage: '',
      },
    }),
    [PROGRAMME_FETCH_DATA_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [PROGRAMME_DELETE_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [PROGRAMME_DELETE_SUCCESS]: (state, payload) => ({
      ...state,
      list: state.list.filter((elem) => elem._id !== payload.id),
      loading: false,
      error: {
        errors: null,
        messsage: '',
      },
      deleted: true,
    }),
    [PROGRAMME_DELETE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [PROGRAMME_CLEAR_DATA]: (state) => ({
      ...initialState,
      list: state.list,
    }),
    [PROGRAMME_CREATE_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [PROGRAMME_CREATE_SUCCESS]: (state, payload) => ({
      ...state,
      list: state.list.concat(payload.programme),
      loading: false,
      error: {
        errors: null,
        messsage: '',
      },
      success: true,
      updated: true,
    }),
    [PROGRAMME_CREATE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [PROGRAMME_MODIFY_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [PROGRAMME_MODIFY_SUCCESS]: (state, payload) => ({
      ...state,
      list: !state.list
        ? []
        : state.list.map((elem) => {
            if (elem.id === payload.id) {
              return {
                id: payload.id,
                name: payload.programme.name,
                description: payload.programme.description,
                siteId: payload.programme.siteId,
                screenId: payload.programme.screenId,
                modifiedAt: new Date().toDateString(),
                modifiedBy: payload.programme.modifiedBy,
              };
            }
            return elem;
          }),
      loading: false,
      error: null,
      success: true,
      updated: true,
    }),
    [PROGRAMME_MODIFY_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [PROGRAMME_CLEAN_UP]: (state) => ({
      ...state,
      loading: false,
      error: null,
      success: false,
      deleted: false,
      updated: false,
    }),
    [PROGRAMME_CLEAR_DATA_LOGOUT]: () => ({
      ...initialState,
    }),
    [SET_PROGRAMME]: (state, payload) => ({
      ...state,
      programme: payload.data,
    }),
  },
  initialState
);
